import { Button, Input, Modal, ActionButton } from "components"
import { Fragment } from "react";
// Third-Party Libraries
import toast from "react-hot-toast"
// Types
import type { ErrorFetch, SuccessFetch } from "types"
// Utils
import { useApi, useToggle } from "utils"
import { CardType } from "../types";
import { PERMISION } from "security";

export function Delete(props: {
    approval_status: number,
    sales_order_id: number,
    data_sales:CardType,
    onSuccess:() => void
}){

    const { isActive, toggle } = useToggle(false)

    return(
        <Fragment>
            {props.approval_status !== 4 && <ActionButton.Delete permission={PERMISION.SALES.REGISTER.BY_CARD.DELETE} onClick={toggle} />}
            {isActive && (
                <DeleteModal
                onSuccess={props.onSuccess}
                toggle={toggle}
                item={{
                    sales_order_id: Number(props.sales_order_id),
                    trx_code: props.data_sales.trx_code,
                    customer: props.data_sales.customer.customer_name ?? '-',
                }}
                />
            )}
        </Fragment>
    )
}

interface DetailDeleteType {
    sales_order_id: number
    trx_code:string
    customer: any
}

function DeleteModal(params: {
    item: DetailDeleteType
    onSuccess: () => void
    toggle: () => void
  }) {
    // Hooks
    const api = useApi()
    const { isActive, setActive } = useToggle(false)
  
    const onDelete = (): void => {
      setActive(true)
  
      toast.promise(
      api.delete(`salesorder/delete/${params.item.sales_order_id}`),
        {
          loading: "Loading...",
          success: (res: SuccessFetch<{ message: string }>) => res.data.message,
          error: (err: ErrorFetch<{ message: string }>) => err.response.data.message
        }
      ).then(() => {
        params.toggle()
        params.onSuccess()
      }).catch(() => {
      }).finally(() => {
        setActive(false)
      })
    }
  
    return (
      <Modal
        isOpen
        title="DELETE ASSET"
        closeModal={params.toggle}
      >
        <Modal.Body className="flex flex-col gap-3">
          <div className="text-error">Are you sure want to delete this data?</div>
  
          <Input
            disabled
            label="SALES ORDER CODE"
            value={params.item.trx_code}
          />
  
          <Input
            disabled
            label="CUSTOMER NAME"
            value={params.item.customer}
          />
        </Modal.Body>
  
        <Modal.Footer>
          <Button
            type="button"
            color="error"
            loading={isActive ? "true" : undefined}
            onClick={onDelete}
            permission={"PR014"}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }